import {
  Button,
  EmptyState,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableSkeleton,
  TableFooter,
  formatRelative,
} from '@westhetics/ui'
import { Link } from 'react-router'
import { LoadError } from '@/app/load-error'
import { routes } from '@/routes'
import { useIntegrationRequests, type Integration } from './api'
import { CHANNEL_LABELS } from './labels'

/**
 * Aba Chamadas (RN-INT-06, P-INT-04): as últimas 100 chamadas do app pela API e pelo MCP, nos 30 dias. Só o molde
 * da rota (ou a ferramenta), o status e a duração: nunca parâmetro nem corpo (RT-23). A escrita está também na
 * trilha da clínica, com o app como autor.
 */
export function RequestsTab({ integration }: { integration: Integration }) {
  const query = useIntegrationRequests(integration.id)
  const items = query.data ?? []

  if (query.isError) {
    return (
      <LoadError
        title="Não conseguimos carregar as chamadas"
        error={query.error}
        onRetry={() => void query.refetch()}
      />
    )
  }
  if (query.isPending) return <TableSkeleton rows={5} columns={5} />
  if (items.length === 0) {
    return (
      <EmptyState
        title="Nenhuma chamada nos últimos 30 dias"
        description="Quando o sistema usar a chave, cada chamada aparece aqui com a rota, o status e quanto tempo levou. O teste da chave está em Visão geral."
        action={
          <Button variant="outline" asChild>
            <Link to={`${routes.admin.integration(integration.id)}?tab=overview`}>
              Testar a chave
            </Link>
          </Button>
        }
      />
    )
  }
  return (
    <div>
      <Table>
        <TableHeader>
          <tr>
            <TableHead>Rota</TableHead>
            <TableHead>Canal</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Duração</TableHead>
            <TableHead>Quando</TableHead>
          </tr>
        </TableHeader>
        <TableBody>
          {items.map((request) => (
            <TableRow key={request.id}>
              <TableCell primary className="break-all">
                <code className="font-body text-[13px] font-normal">
                  {request.channel === 'api' ? `${request.method} ` : ''}
                  {request.route}
                </code>
              </TableCell>
              <TableCell label="Canal" muted>
                {CHANNEL_LABELS[request.channel]}
              </TableCell>
              <TableCell label="Status" muted numeric>
                {request.status}
              </TableCell>
              <TableCell label="Duração" muted numeric>
                {request.durationMs} ms
              </TableCell>
              <TableCell label="Quando" muted>
                {formatRelative(new Date(request.occurredAt))}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <TableFooter>
        <span>
          {items.length} {items.length === 1 ? 'chamada' : 'chamadas'} · as mais recentes primeiro ·
          sem parâmetro nem corpo
        </span>
      </TableFooter>
    </div>
  )
}
